import React from "react";
import { TranslationIssues } from "./types";

interface LanguageSelectorProps {
  languages: string[];
  selectedLang: string;
  masterLang: string;
  onSelect: (lang: string) => void;
  issues?: Record<string, TranslationIssues>;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  languages,
  selectedLang,
  masterLang,
  onSelect,
  issues = {},
}) => {
  return (
    <div className="flex space-x-1 mb-6">
      {languages.map((lang) => {
        const isSelected = lang === selectedLang;
        const isMaster = lang === masterLang;
        const langIssues = issues[lang] || { missingKeys: [], emptyValues: [] };
        const hasIssues =
          langIssues.missingKeys.length > 0 ||
          langIssues.emptyValues.length > 0;

        return (
          <button
            key={lang}
            onClick={() => onSelect(lang)}
            className={`
              px-4 py-2 rounded-md font-medium
              ${
                isSelected
                  ? "bg-cyan-600 text-white"
                  : "bg-white hover:bg-gray-100 text-gray-800"
              }
              ${
                isMaster ? "border-2 border-cyan-300" : "border border-gray-300"
              }
              ${hasIssues ? "ring-2 ring-amber-300" : ""}
              flex items-center space-x-2
            `}
          >
            <span>{lang.toUpperCase()}</span>
            {isMaster && (
              <span className="text-xs bg-cyan-200 text-cyan-800 px-1 rounded">
                Master
              </span>
            )}
            {hasIssues && (
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-amber-100 text-amber-600 text-xs">
                {langIssues.missingKeys.length + langIssues.emptyValues.length}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSelector;
